import type { SVGProps } from 'react'

const NoResultIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#a)" fill="#0A0909">
			<path d="M35.266 0H4.735A4.74 4.74 0 0 0 0 4.735v30.53A4.74 4.74 0 0 0 4.735 40h30.53A4.74 4.74 0 0 0 40 35.266V4.735A4.74 4.74 0 0 0 35.266 0M4.735 2.344h30.53a2.393 2.393 0 0 1 2.391 2.39v3.047H2.344V4.735a2.393 2.393 0 0 1 2.39-2.391m30.53 35.312H4.736a2.393 2.393 0 0 1-2.391-2.39v-25.14h35.312v25.14a2.393 2.393 0 0 1-2.39 2.39" />
			<path d="M5.146 6.234h1.196a1.172 1.172 0 1 0 0-2.343H5.146a1.172 1.172 0 0 0 0 2.343m4.335 0h1.196a1.172 1.172 0 1 0 0-2.343H9.48a1.172 1.172 0 0 0 0 2.343m4.326 0H15a1.172 1.172 0 0 0 0-2.343h-1.195a1.172 1.172 0 0 0 0 2.343m6.077 7.351c-5.695 0-10.328 4.633-10.328 10.329 0 5.694 4.633 10.328 10.328 10.328 5.696 0 10.329-4.633 10.329-10.328 0-5.696-4.633-10.329-10.329-10.329m0 18.313c-4.402 0-7.985-3.582-7.985-7.984s3.583-7.985 7.985-7.985 7.985 3.582 7.985 7.985c0 4.402-3.582 7.984-7.985 7.984" />
			<path d="M23.299 20.496a1.17 1.17 0 0 0-1.657 0l-1.76 1.76-1.76-1.76a1.172 1.172 0 0 0-1.657 1.658l1.76 1.76-1.76 1.759a1.171 1.171 0 1 0 1.657 1.657l1.76-1.76 1.76 1.76a1.17 1.17 0 0 0 1.657 0c.457-.457.457-1.2 0-1.657l-1.76-1.76 1.76-1.76a1.17 1.17 0 0 0 0-1.657" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h40v40H0z" />
			</clipPath>
		</defs>
	</svg>
)
export default NoResultIcon
